import mainCss from "./style/main.css";
export default {
  addStyles() {
    if (document.querySelector("[data-owner='doughnut']")) {
      return;
    }

    const style = document.createElement("style");
    style.innerHTML = mainCss;
    style.setAttribute("data-owner", "doughnut");
    document.head.appendChild(style);
  }

};